// extracted by mini-css-extract-plugin
export default {"root":"WaMJs0","bg":"zTjBPK"};